module.exports = __webpack_public_path__ + "media/tts_g1_d.d16333e9.mp3";